import { trackError } from 'util/error';
import { uapiFetcher } from 'util/UAPI';
import { CREATE_PLANTING_PRESCTIPTION_MUTATION } from './mutations';
import {
  GeneratePlantingPrescriptionMutationParams,
  GeneratePlantingPrescriptionResponse,
} from './types';

const headers = { 'X-feature-flag': 'test_prescriptions' };

export const generatePlantingPrescription = async (
  input: GeneratePlantingPrescriptionMutationParams
): Promise<GeneratePlantingPrescriptionResponse> => {
  try {
    return await uapiFetcher<GeneratePlantingPrescriptionResponse>(
      CREATE_PLANTING_PRESCTIPTION_MUTATION,
      { input },
      headers
    );
  } catch (error) {
    trackError(new TypeError('Could not call "generatePlantingPrescription" mutation'), { error });
    throw error;
  }
};
